/* eslint-disable */
export default {
  recentActivities: 'Kürzliche Aktivitäten',
  text: 'Textn.',
  fax: 'Fax',
  voicemail: 'Voicemail',
  call: 'Anruf',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
